// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { loadFonts } from './utils/loadFonts';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

loadFonts();

const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {/* ✅ Wrap the app with PayPalScriptProvider */}
    <PayPalScriptProvider options={{ "client-id": PAYPAL_CLIENT_ID }}>
      <App />
    </PayPalScriptProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
